import React from 'react'
import '../CSS/About.css'

const About = () => {

return(
    <div>
        <h1>About me</h1>
        <div className='personalia-box'>
        <h3>Personalia</h3>
            <p className='personalia-text'>
                I come from Medellín, Colombia. In 2014, I moved to Bergen, Norway to pursue a PhD which
                I concluded in 2018. In 2017, before finishing my PhD, I started to work in the private sector
                and finally decided to do a career change and leave academia. I have also been happily married
                to a wonderful wife since 2017, so all in all, I decided to stay in Norway and live my life here.
                How am I doing in Norway, you ask? I am doing great! Norway has been great to me and I can certainly
                say that I love this country as much as I love Colombia, my country of origin.
            </p>
        </div>
        <img className='personalia-img' alt='' src={require('../Static/Medellin_Bergen.png')}></img>
        <div className='education-box'>

        <h3>Education</h3>
            <p className='education-text'>
            
                I started my higher educational journey in Colombia with a bachelors degree in Engineering Management.
                As it is customary in LATAM, bachelor degrees usually take 5 years instead 4 or 3 as they do in the USA and Europe respectively.
                This extra duration in a bachelors program usually means more possibilites to explore other subjects that are not present in the program's
                core curricullum. This is especially true towards the end of the program. In my case this meant that I got to choose many subjects related
                to quantitative finances, operations research and AI. This made me consider the possibility of taking a masters degree so that I could explore 
                these disciplines further. Thus, I decided to do that and got a masters degree in Systems Engineering. Initially I wanted to structure my masters thesis
                in such a way that it would help to advance my career in the private sector, that is, outside of academia. Nevertheless, as I advanced through the program,
                my thesis got more and more theoretical to the point that it became apparent that my thesis was not going to be applied thesis at the end. In the midst of this
                realization, and thanks to multiple discussions with my masters thesis supervisor, I became more and more interested in pursuing a PhD. Soon after, I started to
                colaborate with a professor from the University of Bergen who was the PhD supervisor of my master thesis' supervisor. After sometime collaborating with him, he informed me
                about a PhD position in the University of Bergen that was soon to be announced. While I was initially apprehensive about applying, as this position would require me to
                leave my home country, with all the sacrifices that would entail (leaving friends, family, etc) his encouragement and my interest in pursuing a PhD led me to apply. Soon after
                I got the news that I was the happy winner of such PhD position, hence I moved from Colombia to Norway in August 2014 to do a PhD I completed (defended) in April 2018.
            </p>
        </div>

        <img className='education-img' alt='' src={require('../Static/PhD.jpg')}></img>


        <div className='work-box'>

        <h3> Work experience </h3>
    <p className='work-text'>
            
        <div className='inner-work-text'>
            My work experience can be divided into two. On the one hand, there is my research/teaching experience and on the other hand there is my consulting/tech experience.
            Please refer to my <a href=''>LinkedIn profile</a> to have a detailed chronology of my work experience.
          

            <h4>Research/Teaching experience</h4>
            
            
            I have worked as a researcher for many years both in Colombia and Norway. While most of my experience has been linked to upper education institutes (especially universities).
            I have also been part of institutions of international collaboration that are not circunscribed to either 
            of these countries. 
            

            <h4>Consultancy/tech experience</h4>
            
            
            Ever since I was close to finishing my bachelor's degree I have been involved in multiple organizations in the private as well as the public sector. That being said, it is worth
            mentioning that my consultancy focus has significantly increased since 2017 up until today
            
        </div>
    </p>
        </div>
        <img className='work-img' alt='' src={require('../Static/Conference_MIT.jpg')}></img>


        <div className='hobbies-box'>

        <h3>Hobbies and interests</h3>

        <p className='hobbies-text'>    
            
            <div className='inner-hobbies-text'>
                I have multiple hobbies and interest, my main ones are:

                <h4>Reading:</h4> 
                
                I love reading every day and learning about different topics. My favourite topics to read about (besides tech-realted stuff) are history, politics an philosophy.
                I also like to read about finances, health and fitness, and investments. Reading is definetly a staple for my daily routine.

                <h4>Quantitative finances: </h4>
                
                I am very passionate about smart investment strategies and how financial markets can be understood and analyzed. In this sense, I always strive to dedicate a few
                hours per week to reading about, designing and implementing algoritms and other solutions to process economic and financial data. This is one of the hobbies that keeps me very active intellectually and
                financially sharp.


                <h4>Martial arts:</h4>  
                
                I am passionate about martial arts, especially those that have a combat sport component. I have had the privilege to train MMA, Kickboxing, Boxing and BJJ for several years.
                I am always happy to learn other martial arts and have a friendly sparring session with friends and colleagues who share this passion. I don't get to train as much as I used to during my teens and early twenties 
                but I always to my best to do something martial arts related at least a few times every week.

                <h4>Strength training:</h4>  
                
                I have been doing strength training for many years now. I even dabbled in powerlifting a little a bit some years ago. The health and well-being benefits I have perceived from strenght training
                have been amazing. From athleticism to sleeping better, this hobby is certainly an important part of my life.

                <h4>Languages:</h4>  
                
                I have always had an interest for learning languages ever since I was a kid. Right now, I can speak four languages fluently, namely Spanish (my mother tounge), English, French and Norwegian. I would love to learn
                others soon, such as German, Russian and Italian. I believe that learning languages are not only intellectually stimulating but they are also an amazing way to expand one's culture and general knowledge about the world :)

                <h4>Music:</h4>
                
                I have always been interested in music and in learning about different types, techniques and styles. I must admit that this is my most neglected hobby by far though, as I still believe that I don't know anything about music
                nor can I play any instrument proficiently :(. Nevertheless, I definetly have plans to upskill my knowledge and skill in this great hobby as I am sure it will bring great satisfaction and personal realization benefits to my life.
            </div>
        </p>

        </div>
        <img className='hobbies-img' alt='' src={require('../Static/Hobbies.jpg')}></img>
    </div>
)
}


export default About;




// WEBPACK FOOTER //
// ./src/Components/About.js